import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class PumpPrimerAndUnloadTypeFeature implements IFlagFeature {
  name = Features.PUMP_PRIMER;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
